import { supabase } from '../../supabaseClient';

const PLATE_REGEX = /[A-Z]{3}-[0-9][0-9A-Z][0-9]{2}/;
const ENDPOINT = `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/lookup-plate`;
const ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const isValidPlate = (plate) =>
  plate && plate.length > 6 && PLATE_REGEX.test(plate);

export const fetchVehicleByPlate = async (plate) => {
  const session = supabase.auth.session();
  const token = session?.access_token;
  if (!token) {
    throw new Error('Sessão expirada');
  }

  const response = await fetch(ENDPOINT, {
    method: 'POST',
    headers: {
      apikey: ANON_KEY,
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ plate: plate.replace('-', '') }),
  });

  if (!response.ok) {
    throw new Error('Erro na requisição');
  }

  const result = await response.json();
  const vehicle = result?.data;
  if (!vehicle) return null;
  return { ...vehicle, plate };
};
